import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Mail, MessageCircle, MapPin } from "lucide-react";

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const r = await api.post("/contact", form);
      toast.success(r.data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Failed to send"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen" data-testid="contact-page">
      <Navbar />
      <section className="max-w-6xl mx-auto px-6 py-20">
        <div className="label-eyebrow">Get in touch</div>
        <h1 className="font-display text-5xl lg:text-6xl font-black mt-3 leading-tight">We're here, <span className="gold-grad">24/7.</span></h1>
        <div className="grid lg:grid-cols-2 gap-12 mt-12">
          <div className="space-y-6">
            <div className="glass rounded-xl p-5 flex gap-4">
              <Mail className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-1" />
              <div><div className="font-semibold">Email</div><div className="text-sm text-white/60">noreply@duocapitall.com</div></div>
            </div>
            <div className="glass rounded-xl p-5 flex gap-4">
              <MessageCircle className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-1" />
              <div><div className="font-semibold">Live Chat</div><div className="text-sm text-white/60">Duo AI Assistant is online now — click the chat icon at the bottom right.</div></div>
            </div>
            <div className="glass rounded-xl p-5 flex gap-4">
              <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-1" />
              <div><div className="font-semibold">Global Operations</div><div className="text-sm text-white/60">Headquartered in Chicago. Serving investors in 180+ countries.</div></div>
            </div>
          </div>
          <form onSubmit={submit} className="glass-strong rounded-2xl p-7 space-y-4" data-testid="contact-form">
            <Input label="Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required testId="contact-name" />
            <Input label="Email" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required testId="contact-email" />
            <Input label="Subject" value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} required testId="contact-subject" />
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60 block mb-2">Message</label>
              <textarea rows={5} required value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="w-full px-4 py-3 rounded-lg" data-testid="contact-message" />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-50" data-testid="contact-submit">{loading ? "Sending..." : "Send Message"}</button>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}

function Input({ label, testId, ...p }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-widest text-white/60 block mb-2">{label}</span>
      <input {...p} className="w-full px-4 py-3 rounded-lg" data-testid={testId} />
    </label>
  );
}
